import React, { useState, useEffect } from "react";
import { Marker, Popup } from "react-leaflet";
import green from "../assets/images/green.png";
import yellow from "../assets/images/yellow.png";
import orange from "../assets/images/orange.png";
import red from "../assets/images/red.png";
import purple from "../assets/images/purple.png";
import darkred from "../assets/images/darkred.png";
import grey from "../assets/images/grey.png";
import first from "../assets/images/1.png";
import second from "../assets/images/2.png";
import third from "../assets/images/3.png";
import fourth from "../assets/images/4.png";
import fifth from "../assets/images/5.png";
import sixth from "../assets/images/6.png";
import seventh from "../assets/images/7.png";
import GoToStationButton from "./GoToStationButton";

import L from "leaflet";

const MyCustomMarker = (props) => {
  const [markerImg, setMarkerImg] = useState(grey);
  const [status, setStatus] = useState();
  const [imgOfPopup, setImgOfPopup] = useState();
  const [color, setColor] = useState();

  useEffect(() => {
    const setThePropertiesOfAqi = () => {
      if (props.information.AQI !== undefined) {
        let newMarkerImg, newStatus, newImgOfPopup, newColor;

        if (props.information.AQI === 0) {
          // Handle the case when AQI is 0
          newMarkerImg = grey;
          newStatus = "نا معلوم";
          newImgOfPopup = seventh;
          newColor = "rgba(143, 143, 143, 0.3)";
        } else if (props.information.AQI <= 50 && props.information.AQI > 0) {
          newMarkerImg = green;
          newStatus = "پاک";
          newImgOfPopup = first;
          newColor = "rgba(0, 166, 90, 0.3)";
        } else if (props.information.AQI <= 100 && props.information.AQI > 50) {
          newMarkerImg = yellow;
          newStatus = "قابل قبول";
          newImgOfPopup = second;
          newColor = "rgba(255, 215, 0, 0.3)";
        } else if (
          props.information.AQI <= 150 &&
          props.information.AQI > 100
        ) {
          newMarkerImg = orange;
          newStatus = "ناسالم برای گروه های حساس";
          newImgOfPopup = third;
          newColor = "rgba(243, 156, 18, 0.3)";
        } else if (
          props.information.AQI <= 200 &&
          props.information.AQI > 150
        ) {
          newMarkerImg = red;
          newStatus = "ناسالم";
          newImgOfPopup = fourth;
          newColor = "rgba(255, 0, 0, 0.3)";
        } else if (
          props.information.AQI <= 300 &&
          props.information.AQI > 200
        ) {
          newMarkerImg = purple;
          newStatus = "بسیار ناسالم";
          newImgOfPopup = fifth;
          newColor = "rgba(128, 0, 128, 0.3)";
        } else if (
          props.information.AQI <= 500 &&
          props.information.AQI > 300
        ) {
          newMarkerImg = darkred;
          newStatus = "خطرناک";
          newImgOfPopup = sixth;
          newColor = "rgba(128, 0, 0, 0.3)";
        } else if (props.information.AQI > 500) {
          newMarkerImg = grey;
          newStatus = "نا معلوم";
          newImgOfPopup = seventh;
          newColor = "rgba(143, 143, 143, 0.3)";
        }

        // Set state values accordingly
        setMarkerImg(newMarkerImg);
        setStatus(newStatus);
        setImgOfPopup(newImgOfPopup);
        setColor(newColor);
      }
    };

    setThePropertiesOfAqi();
  }, [
    props.information.AQI,
    props.information.latitude,
    props.information.longitude,
    props.information.stationName,
  ]);

  const GetIcon = () => {
    if (!markerImg) {
      // Return null or a default icon until markerImg is defined
      return null;
    }

    return L.icon({
      iconUrl: markerImg,
      iconAnchor: [8, 35],
      popupAnchor: [4, -5],
      iconSize: [25, 38],
    });
  };

  const convertToJalali = (x) => {
    const A = x.slice(0, 10);
    const B = x.slice(11, 19);
    const C = new Date(A);
    const D = new Intl.DateTimeFormat("fa-IR").format(C);
    return D + " " + "(" + B + ")";
  };

  if (
    !props.information ||
    !props.information.latitude ||
    !props.information.longitude
  ) {
    return null; // or handle the case in another way
  }

  const shouldShowTheWord = () => {
    const shouldShow = /^ایستگاه/;
    return !shouldShow.test(props.information.stationName);
  };

  return (
    <div>
      <Marker
        position={[props.information.latitude, props.information.longitude]}
        icon={GetIcon(props.information.AQI)}
        key={props.theKey}
      >
        <Popup
          position={[props.information.latitude, props.information.longitude]}
        >
          <div className="text-center pr-2 pt-2">
            <div width="100%">
              <h6 className="mx-2 d-inline">{status}</h6>
              <img
                className="d-md-inline-block"
                src={imgOfPopup}
                alt={props.information.stationName}
                width={50}
              />
            </div>
            <div className="border p-4" style={{ backgroundColor: color }}>
              {shouldShowTheWord() ? (
                <h6 className="mt-3">
                  ایستگاه {props.information.stationName}
                </h6>
              ) : (
                <h6 className="mt-3">{props.information.stationName}</h6>
              )}
              <h6>
                {props.information.city} - {props.information.province}
              </h6>
              <hr />
              <h6 dir="rtl">شاخص کیفیت هوا (AQI): {props.information.AQI}</h6>
              <h6 dir="rtl">
                آلاینده عامل: <span>{props.information.mainPollutant}</span>
              </h6>
              <hr />
              <h6 dir="rtl">
                آخرین دیتا:
                <span dir="ltr" className="ss01">
                  {convertToJalali(props.information.ccreated_datetime)}
                </span>
              </h6>
              <br />
              <GoToStationButton theRouteUrl={props.information.slug} />
            </div>
          </div>
        </Popup>
      </Marker>
    </div>
  );
};
export default MyCustomMarker;
